import { render, staticRenderFns } from "./token.vue?vue&type=template&id=4c2de8a6&scoped=true&"
import script from "./token.vue?vue&type=script&lang=js&"
export * from "./token.vue?vue&type=script&lang=js&"
import style0 from "./token.vue?vue&type=style&index=0&id=4c2de8a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2de8a6",
  null
  
)

export default component.exports